export default __webpack_public_path__ + "static/media/escalera.942402b7.png";